import React, {
  Dispatch,
  FC,
  SetStateAction,
  useLayoutEffect,
  useState,
} from 'react'
import { Box } from '@mui/material'
import { useDebounce } from '@/hooks'
import { useChangeSet } from '@/utils/useChangeSet'
import cn from '@/utils/cn'
import UnitsHeader from './UnitsHeader'
import UnitsTable from './UnitsTable'

const s = cn('units')

interface IUnits {
  setLoader: Dispatch<SetStateAction<boolean>>
}

const Units: FC<IUnits> = ({ setLoader }) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem('searchValueOrgUnits') ?? ''
  )
  const [isSearch, setIsSearch] = useState(false)
  const [filter, setFilter] = useState<number[]>(
    (localStorage.getItem('filterValueOrgUnits') &&
      JSON.parse(localStorage.getItem('filterValueOrgUnits') ?? '')) ?? [0]
  )

  const handledSearchStr = searchValue.replace(/^ +|( )(?=\1)| +$/g, '')
  const debouncedSearch = useDebounce(handledSearchStr, 3000)

  useChangeSet(() => {
    setIsSearch((prevState) => !prevState)
  }, debouncedSearch)

  useChangeSet(() => {
    localStorage.setItem('searchValueOrgUnits', searchValue)
  }, [searchValue])

  useLayoutEffect(() => {
    window.addEventListener('beforeunload', removeLocalStoradge)
    return () => {
      window.removeEventListener('beforeunload', removeLocalStoradge)
    }
  }, [])

  const removeLocalStoradge = (e: any) => {
    e.preventDefault()
    localStorage.removeItem('searchValueOrgUnits')
    localStorage.removeItem('pageOrgUnits')
    localStorage.removeItem('filterValueOrgUnits')
  }

  return (
    <Box className={s()}>
      <UnitsHeader
        filter={filter}
        setFilter={setFilter}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setIsSearch={setIsSearch}
      />
      <UnitsTable
        isSearch={isSearch}
        searchValue={searchValue}
        filter={filter}
        setSearchValue={setSearchValue}
        setLoader={setLoader}
      />
    </Box>
  )
}

export default Units
